import { useState, useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import handleHttpError from '@/shared/services/HandleHttpError';
import useExtractDocumentDataPreview from './useExtractDocumentDataPreview';
const messages = defineMessages({
    DocumentDataExtracted: {
        id: 'DocumentDataExtracted',
        defaultMessage: 'Data extracted successfully',
    },
    DocumentDataExtractionFailed: {
        id: 'DocumentDataExtractionFailed',
        defaultMessage: 'Failed to extract data',
    },
    DocumentDataExtractionInsufficientData: {
        id: 'DocumentDataExtractionInsufficientData',
        defaultMessage: 'Not enough data found in the document to continue processing',
    },
});
const useDocumentExtraction = ({ onExtracted }) => {
    const intl = useIntl();
    const extractMutation = useExtractDocumentDataPreview();
    const [extractingDocumentId, setExtractingDocumentId] = useState(null);
    const [extractedFromDocumentId, setExtractedFromDocumentId] = useState(null);
    const handleExtractDocument = useCallback((documentId) => {
        setExtractingDocumentId(documentId);
        extractMutation.mutate(documentId, {
            onSuccess: (data) => {
                setExtractingDocumentId(null);
                if (!data.success) {
                    ToastrService.error(intl.formatMessage(messages.DocumentDataExtractionFailed));
                    return;
                }
                if (data.code === 18002 || !data.extractedData) {
                    ToastrService.info(intl.formatMessage(messages.DocumentDataExtractionInsufficientData));
                    return;
                }
                onExtracted(data.extractedData, documentId);
                setExtractedFromDocumentId(documentId);
                ToastrService.success(intl.formatMessage(messages.DocumentDataExtracted));
            },
            onError: (error) => {
                setExtractingDocumentId(null);
                handleHttpError(intl)(error);
            },
        });
    }, [extractMutation, intl, onExtracted]);
    return { extractingDocumentId, extractedFromDocumentId, handleExtractDocument };
};
export default useDocumentExtraction;
